import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress",
    style: {"position":"relative"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "progress-bar indeterminate" })
  ])
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "row justify-content-center mb-4" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  action: "#",
  id: "formUserData",
  autocomplete: "off"
}
const _hoisted_13 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_14 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_15 = {
  key: 1,
  class: "row d-flex justify-content-center"
}
const _hoisted_16 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_17 = {
  key: 2,
  class: "row d-flex justify-content-center"
}
const _hoisted_18 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_19 = {
  key: 3,
  class: "row d-flex justify-content-center"
}
const _hoisted_20 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_21 = {
  key: 4,
  class: "row d-flex justify-content-center"
}
const _hoisted_22 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_23 = {
  key: 5,
  class: "row d-flex justify-content-center"
}
const _hoisted_24 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_25 = {
  key: 6,
  class: "row d-flex justify-content-center"
}
const _hoisted_26 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_27 = {
  key: 7,
  class: "row d-flex justify-content-center"
}
const _hoisted_28 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_29 = {
  key: 8,
  class: "row d-flex justify-content-center"
}
const _hoisted_30 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_31 = {
  key: 9,
  class: "row d-flex justify-content-center"
}
const _hoisted_32 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_33 = {
  key: 10,
  class: "row d-flex justify-content-center"
}
const _hoisted_34 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_35 = { class: "row d-flex justify-content-center form-group" }
const _hoisted_36 = { class: "form-check col-xl-8 col-md-10 col-12" }
const _hoisted_37 = {
  for: "privacy",
  style: {"white-space":"normal !important","overflow":"unset !important","font-weight":"300"}
}
const _hoisted_38 = { class: "row d-flex justify-content-center" }
const _hoisted_39 = { class: "col-xl-8 col-md-10 col-12" }
const _hoisted_40 = {
  key: 0,
  class: "form-feedback just-validate-error-label",
  id: "validationCustom03-error-0"
}
const _hoisted_41 = { class: "row d-flex justify-content-center mt-4" }
const _hoisted_42 = { class: "col-xl-8 col-md-10 col-12 d-grid gap-2" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "progress progress-indeterminate"
}
const _hoisted_45 = { class: "visually-hidden" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", {
  class: "progress-bar",
  role: "progressbar"
}, null, -1)
const _hoisted_47 = { class: "row justify-content-center" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_51 = { class: "modal-content" }
const _hoisted_52 = { class: "modal-header" }
const _hoisted_53 = {
  class: "modal-title h5 no_toc",
  id: "alertPrivacyModalLabel"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, null, -1)
const _hoisted_55 = { class: "modal-body" }
const _hoisted_56 = { class: "modal-footer" }
const _hoisted_57 = {
  class: "modal-dialog modal-dialog-centered modal-xl",
  role: "document"
}
const _hoisted_58 = { class: "modal-content" }
const _hoisted_59 = { class: "modal-header" }
const _hoisted_60 = {
  class: "modal-title h5 no_toc",
  id: "privacyModalLabel"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, null, -1)
const _hoisted_62 = { class: "modal-body" }
const _hoisted_63 = { class: "modal-footer" }

import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import { useWidget } from "../../composables/useWidget";
import { useTenantConfig } from "../../composables/useTenantConfig";
import { useFormValidation } from "../../composables/useFormValidation";
import { useI18n } from "vue-i18n";
import api from "@/services/BookingService";
import _ from "lodash";
import { TenantBookingConfiguration } from "@/models/Configuration/TenantBookingConfiguration";
import Utils from "../../models/Utils/utils";
import { VueRecaptcha } from "vue-recaptcha";
import Privacy from "../../components/Privacy.vue";
import { FormValidate, Modal } from "bootstrap-italia";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecallUserData',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const { recaptchaClientKey, rootElement } = useWidget();
const formValidation = useFormValidation();
const { hasConfiguration } = useTenantConfig();
const { t } = useI18n();

const recaptcha = ref(null);
const localeCode = ref("it-IT");

const name = ref("");
const lastname = ref("");
const mobilephone = ref("");
const email = ref("");
const cf = ref("");
const pod = ref("");
const usercode = ref("");
const address = ref("");
const city = ref("");
const servicecode = ref("");
const invoicenumber = ref("");
const authnReqId = ref("");

const forceSeePrivacy = ref(false);
const hasSeenPrivacy = ref(false);
const hasAcceptedPrivacy = ref(false);

const nameVisibility = ref(true);
const lastNameVisibility = ref(true);
const mobilePhoneVisibility = ref(true);
const emailVisibility = ref(true);
const taxCodeVisibility = ref(true);
const podVisibility = ref(true);
const userCodeVisibility = ref(false);
const addressVisibility = ref(false);
const cityVisibility = ref(false);
const serviceCodeVisibility = ref(false);
const invoiceNumberVisibility = ref(false);

const nameRequired = ref(true);
const lastNameRequired = ref(true);
const mobilePhoneRequired = ref(true);
const emailRequired = ref(true);
const taxCodeRequired = ref(false);
const podRequired = ref(false);
const userCodeRequired = ref(false);
const addressRequired = ref(false);
const cityRequired = ref(false);
const serviceCodeRequired = ref(false);
const invoiceNumberRequired = ref(false);

const reCaptchaError = ref(false);

const tokenReCaptcha = ref("");

const loading = ref(false);
const error = ref(false);
const errorMessage = ref("");

const saving = ref(false);
const saveError = ref(false);
const saveErrorMessage = ref("");

const alertPrivacyRef = ref(null);
const privacyRef = ref(null);

let alertPrivacyModal: any;
let privacyModal: any;

const attentionTitle = computed(() => {
  return t("common.attention");
});

const privacyTitle = computed(() => {
  return _.capitalize(t("privacy.privacyLink"));
});

let validate: any;

onMounted(async () => {
  localeCode.value = t("settings.localeCode");
  alertPrivacyModal = new Modal(alertPrivacyRef.value, { backdrop: "static" });
  privacyModal = new Modal(privacyRef.value, { backdrop: "static" });
  validate = new FormValidate("#formUserData", {
    errorFieldCssClass: "is-invalid",
    errorLabelCssClass: "form-feedback",
    errorLabelStyle: "",
    focusInvalidField: true,
    successLabelCssClass: "labelblack",
  });

  await manageFieldsVisibility();
  manageFieldsValidation();
});

const manageFieldsVisibility = async () => {
  if (hasConfiguration.value) {
    var res = await api.getService(parseInt(store.stepsMade.service.id));
    if (res && res.data) {
      const selectedService = res.data;
      const tenantConfigs = Utils.getGenericConfig(store.tenantConfig.configurations.tenant) as TenantBookingConfiguration;
      if (
        _.isNull(tenantConfigs) === false &&
        _.isUndefined(tenantConfigs) === false
      ) {
        forceSeePrivacy.value = tenantConfigs.tenantOpenprivacytext
          .value as boolean;
      }

      const fieldsVisibility: string[] = selectedService.fields.split("|");

      nameVisibility.value = fieldsVisibility.includes("firstname");
      lastNameVisibility.value = fieldsVisibility.includes("lastname");
      mobilePhoneVisibility.value = fieldsVisibility.includes("mobilephone");
      emailVisibility.value = fieldsVisibility.includes("email");
      taxCodeVisibility.value = fieldsVisibility.includes("cf");
      userCodeVisibility.value = fieldsVisibility.includes("usercode");
      addressVisibility.value = fieldsVisibility.includes("address");
      cityVisibility.value = fieldsVisibility.includes("city");
      serviceCodeVisibility.value = fieldsVisibility.includes("servicecode");
      invoiceNumberVisibility.value = fieldsVisibility.includes("invoicenumber");
      podVisibility.value = fieldsVisibility.includes("pod");

      const fieldsRequired: string[] = selectedService.requiredFields.split("|");

      if (fieldsRequired.length > 0) {
        nameRequired.value = fieldsRequired.indexOf("firstname") >= 0;
        lastNameRequired.value = fieldsRequired.indexOf("lastname") >= 0;
        mobilePhoneRequired.value = fieldsRequired.indexOf("mobilephone") >= 0;
        emailRequired.value = fieldsRequired.indexOf("email") >= 0;
        taxCodeRequired.value = fieldsRequired.indexOf("cf") >= 0;
        userCodeRequired.value = fieldsRequired.indexOf("usercode") >= 0;
        addressRequired.value = fieldsRequired.includes("address");
        cityRequired.value = fieldsRequired.includes("city");
        serviceCodeRequired.value = fieldsRequired.includes("servicecode");
        invoiceNumberRequired.value = fieldsRequired.includes("invoicenumber");
        podRequired.value = fieldsRequired.includes("pod");
      }
      loading.value = false;
    }
  }
};

const manageFieldsValidation = () => {
  if (nameVisibility.value && nameRequired.value) {
    validate.addField("#firstName", [
      {
        rule: "required",
        errorMessage: t("required.firstName"),
      },
    ]);
  }

  if (lastNameVisibility.value && lastNameRequired.value) {
    validate.addField("#lastName", [
      {
        rule: "required",
        errorMessage: t("required.lastName"),
      },
    ]);
  }

  if (mobilePhoneVisibility.value) {
    if (mobilePhoneRequired.value) {
      validate.addField("#mobilephone", [
        {
          rule: "required",
          errorMessage: t("required.phoneNumber"),
        },
      ]);
    }

    if (process.env.VUE_APP_SKIP_PHONE_NUMBER_VALIDATION !== "true") {
      validate.addField("#mobilephone", [
        {
          validator: (value: string) => {
            if (!formValidation.validatePhoneNumber(value)) {
              return false;
            }
            return true;
          },
          errorMessage: t("invalid.phoneNumber"),
        },
      ]);
    }
  }

  if (emailVisibility.value) {
    if (emailRequired.value) {
      validate.addField("#email", [
        {
          rule: "required",
          errorMessage: t("required.emailAddress"),
        },
      ]);
      validate.addField("#email", [
        {
          validator: (value: string) => {
            return (value.length > 0 && !formValidation.validateEmail(value));
          },
          errorMessage: t("invalid.emailAddress"),
        },
      ]);
    }
    else {
      validate.addField("#email", [
        {
          validator: (value: string) => {
            if (value.length > 0 && !formValidation.validateEmail(value)) {
              return false;
            }
            return true;
          },
          errorMessage: t("invalid.emailAddress"),
        },
      ]);
    }
  }

  if (taxCodeVisibility.value) {
    if (taxCodeRequired.value) {
      validate.addField("#cf", [
        {
          rule: "required",
          errorMessage: t("required.taxCode"),
        },
      ]);
    }
    validate.addField("#cf", [
      {
        validator: (value: string) => {
          if (!formValidation.validateTaxCodeOrPIVA(value)) {
            return false;
          }
          return true;
        },
        errorMessage: t("invalid.taxCode"),
      },
    ]);
  }

  if (podVisibility.value) {
    if (podRequired.value) {
      validate.addField("#pod", [
        {
          rule: "required",
          errorMessage: t("required.pod"),
        },
      ]);
    }
  }

  if (userCodeVisibility.value) {
    if (userCodeRequired.value) {
      validate.addField("#usercode", [
        {
          rule: "required",
          errorMessage: t("required.userCode"),
        },
      ]);
    }
  }

  if (addressVisibility.value) {
    if (addressRequired.value) {
      validate.addField("#address", [
        {
          rule: "required",
          errorMessage: t("required.address"),
        },
      ]);
    }
  }

  if (cityVisibility.value) {
    if (cityRequired.value) {
      validate.addField("#city", [
        {
          rule: "required",
          errorMessage: t("required.city"),
        },
      ]);
    }
  }

  if (serviceCodeVisibility.value) {
    if (serviceCodeRequired.value) {
      validate.addField("#servicecode", [
        {
          rule: "required",
          errorMessage: t("required.serviceCode"),
        },
      ]);
    }
  }

  if (invoiceNumberVisibility.value) {
    if (invoiceNumberRequired.value) {
      validate.addField("#invoicenumber", [
        {
          rule: "required",
          errorMessage: t("required.invoiceNumber"),
        },
      ]);
    }
  }

  validate.addField("#privacy", [
    {
      rule: "required",
      errorMessage: t("required.privacy"),
    },
  ]);
};

const nameLabel = computed(() => {
  let label = t("common.firstName");
  if (nameRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const lastNameLabel = computed(() => {
  let label = t("common.lastName");
  if (lastNameRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const podLabel = computed(() => {
  let label = t("common.pod");
  if (podRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const mobilePhoneLabel = computed(() => {
  let label = t("common.phoneNumber");
  if (mobilePhoneRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const emailLabel = computed(() => {
  let label = t("common.emailAddress");
  if (emailRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const taxCodeLabel = computed(() => {
  let label = t("common.taxCode");
  if (taxCodeRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const userCodeLabel = computed(() => {
  let label = t("common.userCode");
  if (userCodeRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const addressLabel = computed(() => {
  let label = t("common.address");
  if (addressRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const cityLabel = computed(() => {
  let label = t("common.city");
  if (cityRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const serviceCodeLabel = computed(() => {
  let label = t("common.serviceCode");
  if (serviceCodeRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const invoiceNumberLabel = computed(() => {
  let label = t("common.invoiceNumber");
  if (invoiceNumberRequired.value) {
    label = label + " *";
  } else {
    label = label + " (" + t("common.optional") + ")";
  }
  return label;
});

const recaptchaValid = computed(() => {
  if (!formValidation.validateText(tokenReCaptcha.value)) {
    return false;
  }
  return true;
});

const openAlertPrivacyDialog = () => {
  alertPrivacyModal.show();
};

const onPrivacyChanged = () => {
  if (!hasSeenPrivacy.value && forceSeePrivacy.value) {
    hasAcceptedPrivacy.value = false;
    openAlertPrivacyDialog();
  }
};

const openPrivacyDialog = () => {
  privacyModal.show();
};

const closePrivacyDialog = () => {
  alertPrivacyModal.hide();
  privacyModal.hide();
  hasSeenPrivacy.value = true;
};

const onCaptchaVerified = (token: any) => {
  tokenReCaptcha.value = token;
};
const onCaptchaExpired = () => {
  tokenReCaptcha.value = "";
  (recaptcha as any).reset();
};

const submitBook = () => {
  if (recaptchaValid.value && validate.isValid) {
    if (_.isNull(store.stepsMade) === false) {
      saving.value = true;

      if (cf.value == null) {
        cf.value = "";
      }

      if (name.value == null) {
        name.value = "";
      }

      const data = {
        serviceId: store.stepsMade.service.id,
        tenantId: store.tenantSelected.id,
        bookingSourceCode: "web",
        firstName: name.value,
        lastName: lastname.value,
        taxCode: cf.value.toUpperCase(),
        mobilePhone: mobilephone.value,
        pod: pod.value,
        email: email.value,
        street: address.value,
        city: city.value,
        serviceIdentificationCode: servicecode.value,
        billNumberSubjectRequest: invoicenumber.value,
        customerCode: usercode.value,
        reCaptchaToken: tokenReCaptcha.value,
        reCaptchaPublicKey: recaptchaClientKey.value,
      };

      api
        .submitRecall(data)
        .then(() => {
          router.push({ name: "summaryRecall" });
        })
        .catch((err) => {
          saveError.value = true;
          if (err.response && err.response.data && err.response.data.details) {
            saveErrorMessage.value = err.response.data.details[0].value;
          }
          console.log("RICHIESTA DI CONTATTO NON ESEGUITA!");
          console.log(err);
        })
        .finally(() => {
          saving.value = false;
        });
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_KInputText = _resolveComponent("KInputText")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("titles.insertYourData")), 1)
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", null, [
                _createElementVNode("b", null, _toDisplayString(errorMessage.value), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", null, [
                  _createElementVNode("b", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("messages.bookingRecallSMS")), 1),
                    (emailVisibility.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, ". " + _toDisplayString(_unref(t)("messages.bookingRecallEmail")), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("form", _hoisted_12, [
              (nameVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_KInputText, {
                        name: "firstName",
                        id: "firstName",
                        modelValue: name.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                        labelText: nameLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (lastNameVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_KInputText, {
                        name: "lastName",
                        id: "lastName",
                        modelValue: lastname.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastname).value = $event)),
                        labelText: lastNameLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (podVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_KInputText, {
                        name: "pod",
                        id: "pod",
                        modelValue: pod.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pod).value = $event)),
                        labelText: podLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (mobilePhoneVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_KInputText, {
                        name: "mobilephone",
                        id: "mobilephone",
                        modelValue: mobilephone.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mobilephone).value = $event)),
                        labelText: mobilePhoneLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (emailVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_KInputText, {
                        name: "email",
                        id: "email",
                        modelValue: email.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((email).value = $event)),
                        labelText: emailLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (taxCodeVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_KInputText, {
                        name: "cf",
                        id: "cf",
                        modelValue: cf.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cf).value = $event)),
                        labelText: taxCodeLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (userCodeVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_KInputText, {
                        name: "usercode",
                        id: "usercode",
                        modelValue: usercode.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((usercode).value = $event)),
                        labelText: userCodeLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (addressVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_KInputText, {
                        name: "address",
                        id: "address",
                        modelValue: address.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((address).value = $event)),
                        labelText: addressLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (cityVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_KInputText, {
                        name: "city",
                        id: "city",
                        modelValue: city.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((city).value = $event)),
                        labelText: cityLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (serviceCodeVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_KInputText, {
                        name: "servicecode",
                        id: "servicecode",
                        modelValue: servicecode.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((servicecode).value = $event)),
                        labelText: serviceCodeLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (invoiceNumberVisibility.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_KInputText, {
                        name: "invoicenumber",
                        id: "invoicenumber",
                        modelValue: invoicenumber.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((invoicenumber).value = $event)),
                        labelText: invoiceNumberLabel.value
                      }, null, 8, ["modelValue", "labelText"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((hasAcceptedPrivacy).value = $event)),
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (onPrivacyChanged($event))),
                    id: "privacy",
                    name: "privacy"
                  }, null, 544), [
                    [_vModelCheckbox, hasAcceptedPrivacy.value]
                  ]),
                  _createElementVNode("label", _hoisted_37, [
                    _createTextVNode(_toDisplayString(_unref(t)("privacy.privacyTextBeforeLink")) + " ", 1),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _withModifiers(openPrivacyDialog, ["prevent"])
                    }, _toDisplayString(_unref(t)("privacy.privacyLink")), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(t)("privacy.privacyTextAfterLink")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_unref(VueRecaptcha), {
                    id: "googlerecaptcha",
                    ref_key: "recaptcha",
                    ref: recaptcha,
                    loadRecaptchaScript: true,
                    onVerify: onCaptchaVerified,
                    onExpired: onCaptchaExpired,
                    language: localeCode.value,
                    sitekey: _unref(recaptchaClientKey)
                  }, null, 8, ["language", "sitekey"]),
                  (!recaptchaValid.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref(t)("required.recaptcha")), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("button", {
                    type: "submit",
                    onClick: submitBook,
                    class: "btn btn-primary btn-progress",
                    disabled: saving.value
                  }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.confirmBooking")) + " ", 1),
                    (saving.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(t)("common.loadingText")), 1),
                          _hoisted_46
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_43)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                (saveError.value)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_49, _toDisplayString(saveErrorMessage.value), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
    _createElementVNode("div", {
      ref_key: "alertPrivacyRef",
      ref: alertPrivacyRef,
      class: "modal",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "alertPrivacyModalLabel",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("h2", _hoisted_53, _toDisplayString(attentionTitle.value), 1),
            _hoisted_54
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("required.privacyRead")), 1)
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: openPrivacyDialog
            }, _toDisplayString(_unref(t)("privacy.privacyRead")), 1)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      ref_key: "privacyRef",
      ref: privacyRef,
      class: "modal bd-example-modal-xl",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "privacyModalLabel",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("h2", _hoisted_60, _toDisplayString(privacyTitle.value), 1),
            _hoisted_61
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createVNode(Privacy)
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: closePrivacyDialog
            }, _toDisplayString(_unref(t)("privacy.privacySeen")), 1)
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})